/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import {
  V1DeployGitCommit,
  V1DeployGitCommit$Outbound,
  V1DeployGitCommit$outboundSchema,
} from "./v1deploygitcommit.js";

/**
 * Create a deployment from a pre-built Docker image
 */
export type V1DeployCreateDeploymentRequestBody = {
  /**
   * Project slug
   */
  project: string;
  /**
   * App slug within the project
   */
  app: string;
  /**
   * Git branch name
   */
  branch: string;
  /**
   * Environment slug (e.g., "production", "staging")
   */
  environmentSlug: string;
  /**
   * Docker image reference to deploy
   */
  dockerImage: string;
  /**
   * Optional git commit information
   */
  gitCommit?: V1DeployGitCommit | undefined;
};

/** @internal */
export type V1DeployCreateDeploymentRequestBody$Outbound = {
  project: string;
  app: string;
  branch: string;
  environmentSlug: string;
  dockerImage: string;
  gitCommit?: V1DeployGitCommit$Outbound | undefined;
};

/** @internal */
export const V1DeployCreateDeploymentRequestBody$outboundSchema: z.ZodType<
  V1DeployCreateDeploymentRequestBody$Outbound,
  z.ZodTypeDef,
  V1DeployCreateDeploymentRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
  branch: z.string(),
  environmentSlug: z.string(),
  dockerImage: z.string(),
  gitCommit: V1DeployGitCommit$outboundSchema.optional(),
});

export function v1DeployCreateDeploymentRequestBodyToJSON(
  v1DeployCreateDeploymentRequestBody: V1DeployCreateDeploymentRequestBody,
): string {
  return JSON.stringify(
    V1DeployCreateDeploymentRequestBody$outboundSchema.parse(
      v1DeployCreateDeploymentRequestBody,
    ),
  );
}
